export const toast = state => {
  return state.notifications.toast;
};
